module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.73f0a88.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/roboto/Roboto-Regular.woff2
// module id = kB1A
// module chunks = 0